<template>
  <div class="extras-option" :class="{selected: selected}" :style="optionStyle" @click="selectOption">
    <span class="extras-option__description" :class="{dark: option.IMAGENURL}">
      {{ option.DESCRIPCION }}
    </span>
    <span class="badge badge-danger extras-option__price" v-if="incPrecio > 0">+{{ incPrecio }}€</span>
    <span class="badge badge-success extras-option__selected" v-if="selected">
      <i class="fa fa-check"/>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    option: { required: true },
    selected: { default: false }
  },
  computed: {
    incPrecio() {
      const { INCPRECIO } = this.option
      return Number(INCPRECIO || 0).toFixed(2)
    },
    optionStyle() {
      const { IMAGENURL } = this.option
      return {
        backgroundImage: `url(${IMAGENURL})`
      }
    }
  },
  methods: {
    selectOption() {
      this.$emit('selectOption', this.option)
    }
  }
}
</script>
<style lang="scss">
.extras-option {
  align-items: flex-end;
  background-color: #f2f2f2;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 0.4rem;
  display: flex;
  font-size: 0.82rem;
  justify-content: center;
  user-select: none;
  padding: 0.4rem;
  position: relative;
  text-align: center;
  overflow: hidden;
  transition: all 0.12s ease-in-out;

  &.selected {
    border: 0.2rem solid #309930;
  }

  &__description {
    font-size: 0.8rem;
    font-weight: bold;
    text-transform: uppercase;
    line-height: 0.9rem;
    padding: 0.2rem;

    @media screen and (max-width: 340px) {
      font-size: 0.7rem;
    }

    &.dark {
      background-color: rgba(#353a40, 0.83);
      color: white;
      font-weight: normal;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  &__price {
    position: absolute;
    top: 0.15rem;
    right: 0.15rem;
    font-weight: normal;
  }

  &__selected {
    position: absolute;
    top: 0.25rem;
    left: 0.25rem;
    font-weight: normal;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Order/OrderAddProductModal/ProductExtrasOption.vue